import { render, staticRenderFns } from "./ProjectForm.vue?vue&type=template&id=728a82a2&scoped=true&"
import script from "./ProjectForm.vue?vue&type=script&lang=js&"
export * from "./ProjectForm.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&"
import style1 from "@/vendor/libs/vue-quill-editor/typography.scss?vue&type=style&index=1&lang=scss&"
import style2 from "@/vendor/libs/vue-quill-editor/editor.scss?vue&type=style&index=2&lang=scss&"
import style3 from "./ProjectForm.vue?vue&type=style&index=3&id=728a82a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "728a82a2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/code/nathan/Sonido_SaaS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('728a82a2')) {
      api.createRecord('728a82a2', component.options)
    } else {
      api.reload('728a82a2', component.options)
    }
    module.hot.accept("./ProjectForm.vue?vue&type=template&id=728a82a2&scoped=true&", function () {
      api.rerender('728a82a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/src/components/projects/ProjectForm.vue"
export default component.exports